/* D1346: freie Lounge-Termine vor dem Klick („Heute frei ab 18:30“).
   Markup und Begründung: snippets/nc-termin-frei.liquid. */
(function () {
  var zeile = document.querySelector('[data-nc-tf]');
  if (!zeile || zeile.dataset.ncTfBereit) return;
  zeile.dataset.ncTfBereit = '1';

  var textEl = zeile.querySelector('[data-nc-tf-text]');
  var texte = (zeile.getAttribute('data-texte') || '').split(' | ');
  var form = zeile.closest('form');
  var sprache = document.documentElement.lang || 'de';
  var ZONE = 'Europe/Berlin';
  var cache = {};

  function varianteAktuell() {
    var id = null;
    try { if (form) id = new FormData(form).get('id'); } catch (e) {}
    if (!id) id = new URLSearchParams(location.search).get('variant');
    if (!id && window._cowProductVariants && window._cowProductVariants[0]) id = window._cowProductVariants[0].id;
    return id ? String(id) : null;
  }

  function kalenderFuer(varianteId) {
    var liste = window.cowServices;
    if (!Array.isArray(liste) || !varianteId) return null;
    for (var i = 0; i < liste.length; i++) {
      var ids = (liste[i].variant_ids || []).map(String);
      if (ids.indexOf(varianteId) >= 0) return liste[i].service_id;
    }
    return null;
  }

  function dauerFuer(varianteId) {
    var vs = window._cowProductVariants || [];
    for (var i = 0; i < vs.length; i++) {
      if (String(vs[i].id) !== varianteId) continue;
      var m = String(vs[i].title || '').match(/(\d+)\s*min/i);
      if (m) return m[1];
    }
    return null;
  }

  function teile(datum) {
    var t = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(datum).forEach(function (p) { t[p.type] = p.value; });
    return t;
  }

  function tagSchluessel(datum) {
    var t = teile(datum);
    return t.year + '-' + t.month + '-' + t.day;
  }

  function monatHolen(kalender, varianteId, dauer, jahr, monat) {
    var url = 'https://app.cowlendar.com/extapi/calendar/' + kalender + '/availability'
      + '?year=' + jahr + '&month=' + monat
      + '&timezone=' + encodeURIComponent(ZONE)
      + '&teammate_id=all&is_manual=false&is_pos=false&adjacent_days=true'
      + (dauer ? '&duration=' + dauer : '')
      + '&variant_id=' + varianteId;
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    });
  }

  function ersterFreier(antwort, jetztSek) {
    var slots = (antwort && antwort.long) || [];
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      if (s.is_bookable && s.qty_left > 0 && s.slot_start_unix > jetztSek) return s;
    }
    return null;
  }

  function suchen(kalender, varianteId) {
    var dauer = dauerFuer(varianteId);
    var jetzt = new Date();
    var t = teile(jetzt);
    var jahr = Number(t.year), monat = Number(t.month);
    var jetztSek = Math.floor(jetzt.getTime() / 1000);
    return monatHolen(kalender, varianteId, dauer, jahr, monat).then(function (a) {
      var s = ersterFreier(a, jetztSek);
      if (s) return s;
      var nj = monat === 12 ? jahr + 1 : jahr, nm = monat === 12 ? 1 : monat + 1;
      return monatHolen(kalender, varianteId, dauer, nj, nm).then(function (b) { return ersterFreier(b, jetztSek); });
    });
  }

  function satz(slot) {
    var start = new Date(slot.slot_start_unix * 1000);
    var zeit = new Intl.DateTimeFormat(sprache, { timeZone: ZONE, hour: '2-digit', minute: '2-digit' }).format(start);
    var heute = tagSchluessel(new Date());
    var morgen = tagSchluessel(new Date(Date.now() + 864e5));
    var tag = tagSchluessel(start);
    var vorlage;
    if (tag === heute) vorlage = texte[0];
    else if (tag === morgen) vorlage = texte[1];
    else vorlage = texte[2];
    if (!vorlage) return '';
    var tagText = new Intl.DateTimeFormat(sprache, { timeZone: ZONE, weekday: 'short', day: '2-digit', month: '2-digit' }).format(start);
    return vorlage.replace('[zeit]', zeit).replace('[tag]', tagText);
  }

  function zeigen() {
    var varianteId = varianteAktuell();
    var kalender = kalenderFuer(varianteId);
    if (!kalender) { zeile.classList.remove('is-da'); return; }
    var schluessel = kalender + ':' + varianteId;
    var gespeichert = null;
    try { gespeichert = JSON.parse(sessionStorage.getItem('nc-tf:' + schluessel) || 'null'); } catch (e) {}
    var frisch = gespeichert && Date.now() - gespeichert.zeit < 5 * 60 * 1000 && gespeichert.slot && gespeichert.slot.slot_start_unix * 1000 > Date.now();
    var weg = frisch ? Promise.resolve(gespeichert.slot) : (cache[schluessel] || (cache[schluessel] = suchen(kalender, varianteId)));
    weg.then(function (slot) {
      if (varianteAktuell() !== varianteId) return;
      if (!frisch) {
        try { sessionStorage.setItem('nc-tf:' + schluessel, JSON.stringify({ zeit: Date.now(), slot: slot ? { slot_start_unix: slot.slot_start_unix } : null })); } catch (e) {}
      }
      var text = slot ? satz(slot) : '';
      textEl.textContent = text;
      zeile.classList.toggle('is-da', !!text);
    }).catch(function () { zeile.classList.remove('is-da'); });
  }

  zeile.addEventListener('click', function () {
    var huelle = form || document;
    var knoepfe = huelle.querySelectorAll('.cowlendar-btn');
    for (var i = 0; i < knoepfe.length; i++) {
      if (knoepfe[i].offsetParent) { knoepfe[i].click(); return; }
    }
  });

  if (form) {
    form.addEventListener('change', function () { setTimeout(zeigen, 50); });
  }
  document.addEventListener('variant:change', function () { setTimeout(zeigen, 50); });

  var los = function () {
    if (window.cowServices) { zeigen(); return; }
    setTimeout(zeigen, 1500);
  };
  if ('requestIdleCallback' in window) {
    window.addEventListener('load', function () { requestIdleCallback(los, { timeout: 2500 }); });
  } else {
    window.addEventListener('load', function () { setTimeout(los, 800); });
  }
})();
